module.exports = __webpack_public_path__ + "static/img/绑定.6786969c.png";